import { Link, useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useRef, useEffect, useMemo } from "react";
import {
  useStripe,
  useElements,
  CardNumberElement, 
  CardCvcElement, 
  CardExpiryElement
} from "@stripe/react-stripe-js";
import { check_stripe_transaction, create_stripe_customer, pre_payment, update_hs_cart_stage } from '../API/APICalls';
import ReCAPTCHA from 'react-google-recaptcha';
import { isatty } from 'tty';


export default function PaymentsForm() {
   
    const location = useLocation();

    const zipsearch = location.state.zipcode;
    const agadata = location.state.aga;
    const golferdata = location.state.inputs;

    const navigate = useNavigate();
    const stripe = useStripe();
    const elements = useElements();
    const [message, setMessage] = useState('');
    const [expiryMessage, setExpiryMessage] = useState('');
    const [cvcMessage, setCvcMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isAutoRenew, setisAutoRenew] = useState(true);
    const [disabled, setDisabled] = useState<boolean>(true);
    const [disabledExpiry, setDisabledExpiry] = useState<boolean>(true);
    const [disabledCvc, setDisabledCvc] = useState<boolean>(true);
    const [usgaTerms, setUsgaTerms] = useState<boolean>(true);
    const [agaTerms, setAgaTerms] = useState<boolean>(true);
    const [expireDate, setExpireDate] = useState<Date>(new Date());


    const [inputs, setInputs] = useState({firstname: golferdata.firstname || '', lastname: golferdata.lastname, phone: golferdata.phone ||'', email: golferdata.email, dob: golferdata.dob ||'' , sex: golferdata.sex|| '', address: golferdata.address || '', address2: golferdata.address2 || '', city:golferdata.city, state:agadata[0].state || '', zip: agadata[0].zipcode ||'', autorenew: agadata[0].allowed_autorenewal, usgaTerms: new Date().toISOString(), agaTerms: '', contact: golferdata.contact || golferdata.contact_guid || '', handicapID: golferdata.handicapID || ''});

    let agaTermsCheckbox = document.getElementById("agaTerms");

    const recaptchaRef = useRef<ReCAPTCHA>(null);
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

    const handleCaptchaChange = (token: string | null) => {
        setIsCaptchaVerified(!!token);
    };


    const resetCaptcha = () => {
        recaptchaRef.current?.reset();
        setIsCaptchaVerified(false);
      };




    //var agadata = JSON.parse(sessionStorage.getItem('aga') || '');
   // var storedzipcode = JSON.parse(sessionStorage.getItem('person') || '');  
   var storedzipcode = golferdata;  
    //console.log(storedzipcode);

    function formatDateAndAddDays(date:any, daysToAdd:any) {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + daysToAdd);
      
        const dd = newDate.getDate().toString().padStart(2, '0');
        const mm = date.toLocaleString('default', { month: 'long' });
        const yyyy = newDate.getFullYear();
      
        return `${mm}, ${dd} ${yyyy}`;
      }

      
      const today = new Date();
    const formattedDate = formatDateAndAddDays(today, 365);



    const handleElementChange = async (event:any)  => {
    
        if (event.elementType=="cardNumber" && event.complete == false) {
         //   setMessage("INCORRECT");
            setDisabled(true);
        }  else {
            setMessage("");
            setDisabled(false);
        }
    }

    const handleElementExpiryChange = async (event:any)  => {
        if (event.elementType=="cardExpiry" && event.complete == false) {
           // setExpiryMessage("INCORRECT");
            setDisabledExpiry(true);
        }  else {
            setMessage('');
            setDisabledExpiry(false);
        }
    }

    const handleElementCvcChange = async (event:any)  => {
        if (event.elementType=="cardCvc" && event.complete == false) {
            //setDisabled(true);
            setDisabledCvc(true);
        }  else {
            setMessage('');
            //setDisabled(false);
            setDisabledCvc(false);
        }
    }

    const handleSelect = async (event: React.ChangeEvent<HTMLInputElement>) => {
        //event.preventDefault();
        
        setUsgaTerms(!usgaTerms);
        
        if (usgaTerms) {
            setUsgaTerms(false);
        } else {
            setUsgaTerms(true);
        }
    }

    const handleAgaSelect = async (event: React.ChangeEvent<HTMLInputElement>) => {
        //event.preventDefault();
        
        setAgaTerms(!agaTerms);
        
        if (agaTerms) {
            setAgaTerms(false);
        } else {
            setAgaTerms(true);
        }
        setInputs({...inputs, agaTerms: new Date().toISOString()});
    }

    const handleAutoRewnewSelect = (event: React.ChangeEvent<HTMLInputElement>) => {

       //event.preventDefault();
        setisAutoRenew(!isAutoRenew);
        setInputs(({ ...inputs, "autorenew": !isAutoRenew }));
    
    }



    
   
    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
       
        //added this to stop double clicks that some customers where doing
        setDisabled(true);

        setIsLoading(true);
     
        const payElement = elements?.getElement(CardNumberElement);
        const payElementExp = elements?.getElement(CardExpiryElement);
        const payElementCVC = elements?.getElement(CardCvcElement);

        if (!payElement ||  !stripe) {
            return;
          }

        const result = await stripe.createPaymentMethod({
            type: "card",
            card: payElement,
            "billing_details": {
                "address": {
                    "city": inputs.city,
                    "country": "US",
                    "line1": inputs.address,
                    "line2": inputs.address2,
                    "postal_code": inputs.zip,
                    "state": inputs.state
                    },
                "email": inputs.email,
                "name": inputs.firstname + " " + inputs.lastname,
                "phone": inputs.phone
            }
          });
          


          //check for pre-paid or debit cards: 
          if (result?.paymentMethod?.card?.funding == "prepaid")
          {
                    //UPDATE CUSTOM OBJECT
                    let update_cart = await update_hs_cart_stage(agadata, '993326960', result, "");
                    setMessage("Only credit cards are accepted.");
                    setIsLoading(false);

          } else {

               
            //check for any already submitted payments
            let check_for_duplicate = await check_stripe_transaction(agadata, inputs);
            //console.log(check_for_duplicate);

            if (JSON.parse(check_for_duplicate || '')?.customer == "Duplicate found" )
            {   
                setMessage("A payment has already been submitted.");
                setIsLoading(false); 
                let update_cart = await pre_payment(agadata, '1060069044', check_for_duplicate, result);

            } else {
            //STEPS TO PROCESS PAYMENT
            //STEP 1: Process PAYMENT in Stripe and check for error states. 
                       
                let stripe_response = await create_stripe_customer(result.paymentMethod?.id, agadata, inputs);
               
               let update_cart = await pre_payment(agadata, '1060069044', stripe_response, result);

                if (JSON.parse(stripe_response || '')?.customer?.stripe_customer.code)
                {
                        setMessage(JSON.parse(stripe_response || '').customer.stripe_customer.message);
                        setIsLoading(false);
                        //UPDATE CUSTOM OBJECT
                        let update_cart = await update_hs_cart_stage(agadata, '993326961', stripe_response, result);
                        return false;
                    
                        
                } else {
                    
                    //customer created successfully 
                    setIsLoading(false);            
                    navigate("/confirmation", {replace: true, state: {aga: agadata} });
                    
                }

            }
        }
    
        
        
    };

    const options = {
        showIcon: true,
        style: {
          base: {
            fontSize: "16px",
            color: "#424770",
            "::placeholder": {
              color: "#aab7c4"
            },
            "::focus": {
              color: "#424770"
            }
          },
          invalid: {
            color: "#fa755a",
            iconColor: "#fa755a"
          }
        }
    }

    useEffect(() => {

       
         if (inputs.autorenew == "false" || inputs.autorenew == false)
         {
          
             setisAutoRenew(false);
             setInputs(({ ...inputs, "autorenew": false }));
          
         }

        
        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
          }
          //const cardElement = elements.getElement(CardNumberElement);
         
          if (agaTermsCheckbox === null)
          {
            setAgaTerms(false);
          }
          
      
    }, [disabled, disabledExpiry, disabledCvc, usgaTerms, agaTerms, isAutoRenew]);



    return(
        <div className="container page_container mb-5 pb-1">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mx-auto">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"><h1 className="fs-1 text-left">Review & Pay</h1></div>
            <form onSubmit={handleSubmit}> 
            
            {isLoading ? 
            <div className="loaderWrapper">
              <div className="loader"></div>
              <div className="loaderWrappertext text-center">We are processing your payment!<br/>Please wait for your confirmation and do not refresh this screen.</div>              
            </div>
            : ''}
            
            <div className="col-sm-12 col-12 col-md-12 col-lg-12">     
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            
           
            <div className="card my-3 border-0 bg-grey">
                
                <div className="card-body border-middle px-3 py-3">
                   
                {agadata[0].usga_aga_joint_membership == "Yes"  ?
                    <div className='col-12 col-sm-8 mb-2'><h5 className="card-title">Joint USGA and {agadata[0].aga_name}</h5></div>
                :
                    <div className='col-12 col-sm-8 mb-2'><h5 className="card-title">{agadata[0].aga_club_name}</h5></div>
                }
                    <div className='row col-12'>
                        <div className='col-8 col-sm-10 col-md-9 pt-2'><h6 className="card-subtitle text-body-secondary">One-year membership (365 days)</h6></div>
                        <div className='col-4 col-sm-2 col-md-3 p-0'><h5 className="card-title text-end">${agadata[0].unit_price}</h5></div>
                    </div>
                    {agadata[0].tax !== "0" ? 
                    <div className='row col-12'>
                        <div className='col-9 col-sm-10 col-md-9 pt-2'><h6 className="card-subtitle text-body-secondary">Tax</h6></div>
                        <div className='col-3 col-sm-2 col-md-3 p-0'><h5 className="card-title text-end">${Number.parseFloat(agadata[0].tax).toFixed(2)}</h5></div>
                    </div>
                    : ''}
                    <hr className='border-blue' />
                    <div className='row col-12'>
                        <div className='col-9 pt-2 col-sm-10 col-md-9'><h6 className="card-subtitle fs-5 fw-bold">TOTAL</h6></div>
                        {agadata[0].tax !== "0" ? 
                         <div className='col-3 col-sm-2 col-md-3 p-0'><h5 className="card-title text-end">${Number.parseFloat(agadata[0].price_with_tax).toFixed(2)}</h5></div>
                        : <div className='col-3 col-sm-2 col-md-3 p-0'><h6 className="card-title fs-5 fw-bold text-end">${agadata[0].unit_price}</h6></div>
                        }
                    </div>

                    
                </div>
                </div>
          
            
            
            <div className='row col-12 mb-2'>
                <div className='col-10'><h4>Personal Information</h4></div>
                <div className='col-2 text-end'><Link to="/personal-info" state={{zipcode:zipsearch,aga:location.state.aga, inputs:inputs}} className='fw-medium'>Edit</Link></div>
            </div>
           
            <div className='row'>
                <span className='col-12'>{storedzipcode.firstname} {storedzipcode.lastname}</span>
                <span className='col-12 col-sm-3'>{storedzipcode.phone}</span>
                <span className='col-12 col-sm-8'>{storedzipcode.email}</span>
                <span className='col-12 col-sm-3'>Born {storedzipcode.dob}</span>
                <span className='col-12 col-sm-8'>{storedzipcode.sex ==='M' ? 'Male' : 'Female'}</span>
            </div>
            
            <hr />
            <div className='row col-12 mb-2'>
                <div className='col-10'><h4>Billing Information</h4></div>
                <div className='col-2 text-end'><Link to="/address" state={{zipcode:zipsearch, aga:location.state.aga, inputs:inputs}} className='fw-medium'>Edit</Link></div>
            </div>
            <div className='row'>
                <span className='col-12'>{storedzipcode.address}</span>
                {storedzipcode.address2 ? <span className='col-12'>{storedzipcode.address2}</span> : ''}
                <span className='col-12'>{storedzipcode.city}, {storedzipcode.state} {storedzipcode.zip}</span>
            </div>
            <hr />

            <div className="col-12 col-sm-9"><h4 className="text-left my-4">Payment Details</h4></div>
                       
            <div className="col-12 mb-2">
            <div className="col-12 col-sm-12 mb-1">
                <div className='row'>
                    <div className="col-8 col-sm-6 col-md-7 col-lg-7 col-xxl-7">
                        <label className='pb-2'>Credit Card Number*</label>
                        <CardNumberElement className="border rounded p-2" id="form-control" options={options} onChange={handleElementChange} />
                       
                    </div>
                    <div className='col-3 col-sm-3 col-md-3 col-lg-4 col-xxl-4'>
                        <span id="creditcards"><img src='./assests/cards/accepted_cards.png' className='img img-fluid'/></span>
                    </div>
                </div>
            </div>

                <div className='row'>
                    <div className="col-12 col-sm-6 col-xs-12 mt-3">
                        <label className='pb-2'>Expiration Date*</label>
                        <CardExpiryElement className="border rounded p-2" id="card-element" options={options} onChange={handleElementExpiryChange}/>   
                    </div>
                    
                    <div className="col-12 col-sm-6 col-md-5 mt-3">
                        <label className='pb-2'>Verification Code (CVC)*</label>
                        <CardCvcElement className="border rounded p-2" id="card-element" options={options} onChange={handleElementCvcChange}/>   
                    </div>

                  
                    
                </div>


              


                    
                {/* <div className="row col-12 mt-2 mb-3 form-check form-switch">
                    {/* <div className='col-2 col-lg-2 col-xl-5 col-xxl-5' style={{border:'1px solid red'}}>
                        <input className="form-check-input fs-5" type="checkbox" id="flexSwitchCheckDefault" checked={isAutoRenew} onChange = {handleAutoRewnewSelect}/>
                    </div> */}
                    {/* <div className='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10 ms-2'>
                        <input className="form-check-input fs-5" type="checkbox" id="flexSwitchCheckDefault" checked={isAutoRenew} onChange = {handleAutoRewnewSelect}/> <span className='fs-6 ps-2 ms-1'></span>
                    </div>
                </div> */} 

            
                <div className="row mt-4 mb-3 form-radio-options">
            
                    <div className='col-1 '>

                           
                            
                           
                            <input type="checkbox" className="form-check-input fs-5" name="autorenew" onChange={handleAutoRewnewSelect}  value="isAutoRenew" checked={isAutoRenew}/>
                               
                    </div>  
                        <div className='col-10 fs-6 text-justify'>By enrolling in auto-renew, you understand and agree that your USGA/AGA GC membership will automatically renew at the end of your current membership term and your credit card or payment method on file will be processed unless you take action to cancel before the renewal date.  You may opt-out of auto-renew anytime, but you must opt-out before the scheduled dues processing date to avoid incurring annual charges.  You may opt-out of auto-renew by following the opt-out processes in the <a href="https://www.usga.org/content/usga/home-page/aga/membership-terms.html?__hstc=181257784.17c49f14dc191f275c4faa64e65f038f.1730156592675.1730991799110.1731006041332.12&__hssc=181257784.10.1731006041332&__hsfp=394787271" target='_blank'>Membership Terms and Conditions.</a></div>
                </div>

               
                <div className="row mt-4 mb-3 form-radio-options">
                    <div className='col-1 '><input type="checkbox" className="form-check-input fs-5" name="usga_terms" onChange={handleSelect}  value="USGA" required/></div>
                    <div className='col-10 fs-6'>I agree to the <a href="https://www.usga.org/content/usga/home-page/usga-privacy-policy.html.html?__hstc=181257784.17c49f14dc191f275c4faa64e65f038f.1730156592675.1730991799110.1731006041332.12&__hssc=181257784.10.1731006041332&__hsfp=394787271" target='_blank'>Privacy Policy</a>, <a href="https://www.usga.org/content/usga/home-page/terms-and-conditions.html?__hstc=181257784.17c49f14dc191f275c4faa64e65f038f.1730156592675.1730991799110.1731006041332.12&__hssc=181257784.10.1731006041332&__hsfp=394787271" target='_blank'>Terms of Use</a>, and <a href="https://www.usga.org/content/usga/home-page/aga/membership-terms.html?__hstc=181257784.17c49f14dc191f275c4faa64e65f038f.1730156592675.1730991799110.1731006041332.12&__hssc=181257784.10.1731006041332&__hsfp=394787271" target='_blank'>Membership Terms</a> of the United States Golf Association.</div>
                </div>

                {agadata[0].aga_privacy_policy || agadata[0].aga_terms_of_service ? 
                <div className="row form-radio-options">
                    <div className='col-1'><input type="checkbox" className="form-check-input fs-5" name="usga_terms" onChange={handleAgaSelect} required id="agaTerms"/></div>
                    <div className='col-10 fs-6'>I agree to {agadata[0].aga_name} {agadata[0].aga_privacy_policy ? <a href={agadata[0].aga_privacy_policy} target='_blank'>Privacy Policy</a> : ''} {agadata[0].aga_terms_of_service ? <>and <a href={agadata[0].aga_terms_of_service} target='_blank'>Terms of Service</a>.</> : "" }</div>
                </div> : '' } 
            
                </div>

                <div className="col-12 pt-3">
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey="6Le2pp8qAAAAAFDOLCpmqAvWaOI_ZVxcsl9aA9Bc"  // Replace with your actual site key
                        onChange={handleCaptchaChange}
                     />
                </div>

                <div className='row my-4'>
                {message && <div id="payment-message" className='text-danger'>{message} If you're having trouble, contact the <a className='text-danger' href='mailto:gcsupport@usga.org'>USGA</a>.</div> }
                </div>


                <div className="row mt-4 col-12 col-sm-12 pb-5">
                            <div className="col-12 col-sm-6 col-md-5 order-1 pt-3">
                                <Link replace={true} to="/address" state={{zipcode:zipsearch, aga:location.state.aga, inputs:inputs}} className="w-100 btn btn-outline-secondary btn-lg rounded-pill px-5 " type="button">
                                    BACK
                                </Link>
                            </div>
                            <div className="col-12 col-sm-6 col-md-7 order-sm-1 order-lg-1 pt-3">
                                
                                <button className="btn btn-primary w-100 btn-lg px-4 rounded-pill" type="submit" disabled={disabled || usgaTerms || agaTerms || disabledExpiry || disabledCvc || !isCaptchaVerified} >
                                SUBMIT PAYMENT
                                </button>
                                
                            </div>
                        </div>

                        
            </div>
            
        </div>
        </form>
        
        </div>    
        </div>    
   
    )
}